<!-- Bolha do Chatbot -->
<div
  class="chatbot-bubble"
  (click)="toggleChat()"
  *ngIf="!isChatOpen"
  appTrackClick
  trackEvent="maia_reports"
  trackCategory="chatbot"
  trackLabel="open_chatbot">
  <div class="bubble-content">
    <span class="bubble-text">Olá!</span>
    <img src="assets/icons/helloIcon.png" alt="Olá" class="hello-icon">
    <span class="bubble-text">Posso ajudar?</span>
  </div>
  <img src="assets/images/maiaImage.png" alt="Assistente" class="mai-image">
</div>

<!-- Janela do Chat -->
<div class="chat-window" *ngIf="isChatOpen" [class.chat-pulsing]="isChatPulsing" [class.resizing]="isResizing"
  [style.width.px]="chatWidth" [style.height.px]="chatHeight" #chatWindow>

  <!-- Botão de Redimensionamento CORRETO -->
  <div class="resize-handle" (mousedown)="startResize($event)" (touchstart)="startResize($event)" title="Redimensionar">
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
      <path
        d="M22,22H20V20H22V22M22,18H20V16H22V18M18,22H16V20H18V22M18,18H16V16H18V18M14,22H12V20H14V22M22,14H20V12H22V14Z" />
    </svg>
  </div>

  <div class="chat-header">
    <div class="header-left">
      <img src="assets/images/maiaImage.png" alt="Maia" class="header-avatar">
      <div class="header-info">
        <h3 class="chat-title">MaIA</h3>
        <div class="status">
          <span class="status-dot"></span>
          <span class="status-text">online</span>
        </div>
      </div>
    </div>
    <button class="close-btn" (click)="closeChat()">×</button>
  </div>

  <!-- Área de Mensagens -->
  <div class="chat-messages" #chatMessages>
    <!-- Todas as mensagens -->
    <div *ngFor="let message of messages" class="message" [class.bot-message]="!message.isUser && !message.isTyping"
      [class.user-message]="message.isUser" [class.typing-message]="message.isTyping">
      <div class="message-content">
        <p *ngIf="!message.isTyping" [innerHTML]="message.text | chatMarkdown"></p>
        <div *ngIf="message.isTyping" class="typing-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <span class="message-time" *ngIf="!message.isTyping">
        {{ message.timestamp | date:'HH:mm' }}
      </span>
    </div>
  </div>

  <!-- Question Bubbles -->

  <!-- Input -->
  <div class="chat-input">
    <input type="text" placeholder="Digite sua mensagem..." class="message-input" #messageInput
      (keyup.enter)="sendMessage()" [disabled]="isLoading">
    <button class="send-btn" (click)="sendMessage()" [disabled]="isLoading">
      <img src="assets/icons/sendIcon.png" alt="Enviar" class="send-icon">
    </button>
  </div>
  <div class="question-bubbles-container" *ngIf="showQuestionBubbles">
    <div class="bubbles-scroll-container" #bubblesScrollContainer>
      <div class="bubbles-track" #bubblesTrack>
        <!-- Conteúdo duplicado para loop -->
        <ng-container *ngFor="let question of questionBubbles">
          <app-question-bubble [text]="question.text" (clicked)="sendQuickQuestion(question.text)"
            class="question-bubble-item">
          </app-question-bubble>
        </ng-container>
        <ng-container *ngFor="let question of questionBubbles">
          <app-question-bubble [text]="question.text" (clicked)="sendQuickQuestion(question.text)"
            class="question-bubble-item">
          </app-question-bubble>
        </ng-container>
      </div>
    </div>
  </div>
</div>
